import React from 'react';
/* eslint-disable react/jsx-no-useless-fragment */
import { useState } from 'react';
import { Button, Alert } from 'reactstrap';
import { Link, useNavigate } from 'react-router-dom';
import { callNativeMobileApp, withMobileAppMode } from '@front-activerse/common-components';

interface RemoteConfigFields {
  meal_plan_notification_id: number;
  meal_plan_notification_img: string;
  meal_plan_notification_content: string;
  meal_plan_notification_close_btn_text: string;
  meal_plan_notification_redirect_btn_text?: string;
  meal_plan_notification_redirect_url_path?: string;
}

interface DayPlanNotificationAlertProps {
  userId: number;
  mealPlanNotificationData: RemoteConfigFields;
  getClosedNotificationsValues: () => Promise<void>;
  markNotificationAsClosed: (
    collectionName: string,
    userId: number,
    notificationId: number
  ) => Promise<void>;
  mobileAppMode: boolean;
}

const DayPlanNotificationAlert: React.FC<DayPlanNotificationAlertProps> = ({
  userId,
  mealPlanNotificationData,
  markNotificationAsClosed,
  mobileAppMode,
}) => {
  const {
    meal_plan_notification_id,
    meal_plan_notification_img,
    meal_plan_notification_content,
    meal_plan_notification_close_btn_text,
    meal_plan_notification_redirect_btn_text,
    meal_plan_notification_redirect_url_path,
  } = mealPlanNotificationData;

  const navigate = useNavigate();
  const [isClosed, setIsClosed] = useState(false);

  const handleClose = async () => {
    setIsClosed(true);
    await markNotificationAsClosed('mealplan_notifications', userId, meal_plan_notification_id);
  };

  const handleRedirect = async () => {
    await handleClose();
    if (mobileAppMode) {
      callNativeMobileApp({
        action: 'open_modal',
        payload: {
          path: meal_plan_notification_redirect_url_path,
          modal_variant: 'always_close_btn',
        },
      });
      return;
    }
    meal_plan_notification_redirect_url_path && navigate(meal_plan_notification_redirect_url_path);
  };

  return (
    <>
      {!isClosed ? (
        <Alert color="light" fade={false}>
          {Boolean(meal_plan_notification_img) && (
            <div className="text-center">
              <img src={meal_plan_notification_img} className="border-radius w-100" alt="" />
            </div>
          )}
          <p className={`small mb-l ${meal_plan_notification_img ? 'mt-l' : ''}`}>
            {meal_plan_notification_content}
          </p>
          <div className="text-center">
            <Button color="outline-secondary" size="sm" onClick={handleClose}>
              {meal_plan_notification_close_btn_text}
            </Button>
            {Boolean(
              meal_plan_notification_redirect_btn_text && meal_plan_notification_redirect_url_path
            ) && (
              <Link to="#" onClick={handleRedirect}>
                <Button color="primary" size="sm" className="ms-l">
                  {meal_plan_notification_redirect_btn_text}
                </Button>
              </Link>
            )}
          </div>
        </Alert>
      ) : null}
    </>
  );
};

export default withMobileAppMode(DayPlanNotificationAlert);
